import slideRangLt from './slide-rang-lt';

const install = function (Vue) {
  Vue.component(slideRangLt.name, slideRangLt)
}

export default install
